'use strict'

const OIDC = {
  ACTOR_TYPE_TRUSTED_PUBLISHER: 'trusted_publisher',
  ACTOR_TYPES: ['trusted_publisher'],
  ACTORS: {
    GITHUB: {
      ID: 'github',
      DISPLAY_NAME: 'GitHub Actions',
      EMAIL: 'trusted-publishers@users.noreply.github.com',
    },
    GITLAB: {
      ID: 'gitlab',
      DISPLAY_NAME: 'GitLab CI/CD',
      EMAIL: 'trusted-publishers@users.noreply.github.com',
    },
  },
}

module.exports = {
  OIDC,
}
